import React from 'react'
import { useEffect, useState, useRef, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryGridAr from "../components/EntryGridAr";
import EntrySetting from "../components/EntrySetting";
import EntryRemarks from "../components/EntryRemarks";
import EntryImages from "../components/EntryImages";
import EntryFiles from "../components/EntryFiles";
import EntryBase from "../components/EntryBase";
import DropZone from "../components/DropZone";
import Headline from "../components/Headline";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import { isEmpty, getglobaldata, NumConv, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata, getformid, getcontroller, getsubkey, initializedata, isEnabled, GetDesitRound, GetRound } from '../modules/appLibrary';
import { cfFileUpload, cfNewUploadFile, cfMargeUploadFiles } from '../modules/commodule';
import { setimagelist } from '../modules/imagedlgstore';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption, rerendergrid } from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup } from '../modules/toolpanelstore';
import { render } from 'react-dom';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const RawTransfer = props => {

    const panelsdef = [];
    const G_id = { BASE: "0", MEI: "1", TOTAL: "T1", IMAGE: "pic", FILE: "file", NB: "nb", PL: "pl" }
    const primarykeys = ["ZFR_DENNO"];
    const formid = getformid("RawTransfer", props.location.search);
    const controller = getcontroller("RawTransfer", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const formListOption = useSelector(state => state.form.listoption);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);

    const baseRef = useRef(null);
    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const locationstate = useRef(null);    //遷移State

    const formstatus = useSelector(state => state.form.status);
    const entrylock = useSelector(state => state.form.entryformlock);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [update, setUpdata] = useState(false);
    const [isDragActive, setIsDragActive] = useState(false);
    const [rowContext, setRowContext] = useState(false);
    const gridlist = useSelector(state => state.form.gridlist);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const scrollRef = useRef(null);
    const listoptionRef = useRef('0');        //0:商品 1:加工

    const gridapiRefs = useRef([]);
    const gridcolapiRefs = useRef([]);
    const griddataRefs = useRef([]);
    const gridcolRefs = useRef([]);

    //データ
    const entrydataRef = useRef(null);
    const imageRef = useRef(null);
    const fileRef = useRef(null);

    function SetGridData(panel, data) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        griddataRefs.current[gidx].current = data;
    }
    function GridData(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return griddataRefs.current[gidx].current;
    }
    function SetGridColDef(panel, coldef) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolRefs.current[gidx].current = coldef;
    }
    function SetGridApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridapiRefs.current[gidx].current = api;
    }
    function GridApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridapiRefs.current[gidx].current;
    }
    function SetGridColApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolapiRefs.current[gidx].current = api;
    }
    function GridColApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridcolapiRefs.current[gidx].current;
    }
    const actionurl = {
        "delete": "RawTransfer/Delete",
        "getlist": "RawTransfer/GetListData",
    }
    //動作抑止
    const suppressaction = [
        { type: "0", action: "INSERT" },
        { type: "0", action: "UPDATE" },
        { type: "1", action: "UPDATE" },
        { type: "1", action: "NEW FORM" },
        { type: "1", action: "ENTRY FORM" },
    ];
    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "print", icon: "print", label: "原材料振替伝票発行" },
        { status: "ENTRY FORM", menuid: "sep" },
        { status: "ENTRY FORM", menuid: "print", icon: "print", label: "原材料振替伝票発行" },
    ];
    function normalizeNavmenu(menu) {
        return menu.filter((item, index, source) => {
            if (item.menuid !== "sep") return true;
            const prev = source[index - 1];
            const next = source[index + 1];
            return !isEmpty(prev)
                && !isEmpty(next)
                && prev.status === item.status
                && next.status === item.status
                && prev.menuid !== "sep"
                && next.menuid !== "sep";
        });
    }
    function setEntryMenu(reqFlg, synFlg) {
        // var newmenu = [...navmenu];
        // var hidemenu = null;

        // if (reqFlg == "1" || synFlg == "2" || synFlg == "3") {
        //     hidemenu = [{ status: "ENTRY FORM", cmd: "登録" }, { status: "ENTRY FORM", cmd: "削除" }];
        // }
        // if (!reqFlg || reqFlg == "0" || synFlg == "2" || synFlg == "3") {
        //     newmenu = newmenu.filter(e => e.status === "ENTRY FORM" && e.menuid !== 'reqCancel');
        // }
        // baseRef.current.ChangeNavmenu(newmenu);
        // baseRef.current.hideMenucmd(hidemenu);
    }
    function rerender() {
        setUpdata(update ? false : true);
    }
    function onDragEnter(e) {
        if (entrylock) return;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragActive(true);
        }
    };
    // 主キー取得
    function primarykey() {
        if (isEmpty(columninfo)) return "";
        if (!columninfo.some(e => e.primarykey)) return "";
        return columninfo.find(e => e.primarykey).columnid;
    }
    // 項目名取得
    function nametocolumn(name) {
        if (isEmpty(columninfo)) return "";
        if (!columninfo.some(e => e.columnid.indexOf(name) !== -1)) return "";
        return columninfo.find(e => e.columnid.indexOf(name) !== -1).columnid;
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        // ListTabを取得
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    setcolumninfo(data.colinfo);
                    setcolumns(data.columns);
                    let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
                    settextfieldsall(fields);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    fnc.current.initMaster(data.master);

                    let idx = 0;
                    let glist = [];
                    data.panels.filter(e => e.grid).forEach(function (panel) {
                        gridapiRefs.current[idx] = createRef();
                        gridcolapiRefs.current[idx] = createRef();
                        griddataRefs.current[idx] = createRef();
                        gridcolRefs.current[idx] = createRef();
                        glist.push({ id: panel.id, type: panel.type, index: idx });
                        idx++;
                        let t = data.colinfo.find(e => e.logpid === "T" + panel.id)
                        if (!isEmpty(t)) {
                            //TOTAL用REF作成
                            gridapiRefs.current[idx] = createRef();
                            gridcolapiRefs.current[idx] = createRef();
                            griddataRefs.current[idx] = createRef();
                            gridcolRefs.current[idx] = createRef();
                            glist.push({ id: "T" + panel.id, type: t.type, index: idx });
                            idx++;
                        }
                    });

                    dispatch(setgridlist(glist));

                    if (data.prelayout) {   //レイアウト復元
                        RestoreLayout(data.panels, fields);
                    }

                    //遷移state取得
                    let state = props.location.state;   //history.push
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            //go back
                            state = window.history.state;
                        }
                    }
                    locationstate.current = state;
                    if (!isEmpty(state)) {
                        if ("code" in state) {
                            clearform();
                            dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
                        }
                    }
                    fnc.current.wait(false);
                }
            });
    }, [search]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1); //セクションCLOSEボタン
    }, [menuinfo]);

    useEffect(() => {
        if (formstatus === "COPY FORM") {
            columninfo.filter(e => e.copyclear).forEach(function (col) {
                entrydataRef.current[col.columnid] = "";
            });
            // setEditable(true);
            // setEditableTenjiNo();

            rerender();
        }
    }, [formstatus]);

    //遷移state状態表示
    function callshow() {
        if (locationstate.current.code !== "") {
            Show(undefined, locationstate.current.code)
        } else {
            if (!isEmpty(locationstate.current.acceptno)) {
                clearform();
            }
        }
        locationstate.current = null;   //最初の１度のみ
    }
    function onFirstDataRendered(param, panel) {
        SetGridApi(panel, param.api);
        SetGridColApi(panel, param.api);

        if (!isEmpty(locationstate.current)) {
            let call = true;
            for (let i = 0; i < gridlist.length; i++) {
                if (EmptyPanel(gridlist[i].id, gridlist[i].type)) continue;
                if (isEmpty(GridApi(gridlist[i]))) {
                    call = false; break;
                }
            }
            //遷移表示
            if (call) callshow();
        }
    }
    function Show(data, pushcode, listoption) {
        let code = "";
        if (data === undefined) {
            if (!isEmpty(pushcode)) {   //history.push
                code = pushcode;
                setedittingcode(code);
            } else {
                code = edittingcode;    //再表示
            }
        } else {
            setglobaldata("entryrowdata", data);
            if (data !== null) {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]]; break;
                    }
                }
            }
            setedittingcode(code);
        }
        if (!isEmpty(listoption)) listoptionRef.current = listoption;
        if (isEmpty(columninfo)) return false;    //読み込み前
        clearform(code === "");
        //データ読み込み
        LoadData(code);
        return true;
    }

    //リストレイアウト適用
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e => e.type !== type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
    }
    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    function keepListOptionValue(target, source) {
        if (isEmpty(target)) return target;
        if (isEmpty(formListOption) || formListOption.length === 0) return target;
        let newdata = { ...target };
        formListOption.forEach(option => {
            if (isEmpty(option.columnid)) return;
            if (!isEmpty(source) && source[option.columnid] !== undefined) {
                newdata[option.columnid] = source[option.columnid];
                return;
            }
            if (option.headerfix === 1) {
                newdata[option.columnid] = listoptionRef.current;
            }
        });
        return newdata;
    }
    // スクロール位置を保存する
    function saveScrollPos() {
        scrollRef.current = EntrybodyRef.current.scrollTop;
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        try {
            if (scrollRef.current) EntrybodyRef.current.scrollTop = scrollRef.current;
        } catch { }
    }
    //行データ保持
    function storeRowData(panel) {
        if (panel === undefined) {
            for (let i = 0; i < gridlist.length; i++) {
                SetGridData(gridlist[i], AGRef.current.GetDatasource(GridApi(gridlist[i])));
            }
        } else {
            SetGridData(panel, AGRef.current.GetDatasource(GridApi(panel)));
        }
    }
    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        if (id === G_id.FILE) panelid = 'fileGrid';
        if (id === G_id.NB) panelid = 'remarkspanel' + type;
        if (isEmpty(type)) {
            type = tabletype(id);
        }
        if (panel.some(e => e.id === id && e.type === type && e.grid)) {
            panelid = fnc.current.GridID({ id: id, type: type });
        }
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }
    function MenuAction(action, finallycallback) {
        LayoutSaveStorage();
        if (action === 'save') Save(finallycallback);
        if (action === 'delete') Delete(finallycallback);
        if (action === "clear") clearform(true);
        if (action === 'linkfield') {
            let col = textfields.find(e => e.columnid === finallycallback.field && (isEmpty(finallycallback.type) ? true : e.type === finallycallback.type));
            if (col === undefined) return;
            if (col.logpid == "0") {
                let key = finallycallback.field + "_" + col.type;
                document.getElementById(key).focus();
                document.getElementById(key).select();
                Jump(G_id.BASE, col.type);
                return;
            }
            let logpid = col.logpid;
            Jump(logpid);
            AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, GridApi({ id: logpid }));
        }
        if (action === "print") {
            let code = [];
            if (formstatus === "ENTRY FORM") {
                code = [edittingcode];
            } else {
                let param = baseRef.current?.GetSelectrowdata();
                if (param.length === 0) {
                    fnc.current.warnmsg("対象データを選択してください");
                    return;
                }
                for (let i = 0; i < primarykeys.length; i++) {
                    if (primarykeys[i] in param[0]) {
                        for (let j = 0; j < param.length; j++) {
                            code.push(param[j][primarykeys[i]]);
                        }
                        break;
                    }
                }
            }
            if (code.length === 0) return;
            fnc.current.postaxios('GenzairyoHurikaeReport/Generate', { denNoList: code },
                {
                    onSuccess: function (data) {
                        let params = {
                            "excelfile": data.returnData["filename"],
                            "dnfile": data.returnData["dnfile"]
                        }
                        fnc.current.filedownload("excel/ExcelDownload", params);
                        fnc.current.wait(false);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
            return;
        }
    }
    function buildEntryParamData(nocheck, confirmedTypes) {
        storeRowData();
        SetPLData();

        if (!confirmedTypes) {
            confirmedTypes = [];
        }
        var detail = {};
        for (let i = 0; i < gridlist.length; i++) {
            if (gridlist[i].id === G_id.PL) continue;
            detail[gridlist[i].type] = GridData(gridlist[i].id);
        }
        return {
            "type": listoptionRef.current,
            "controller": formid,
            "data": entrydataRef.current,
            "detail": detail,
            "images": imageRef.current,
            "files": fileRef.current,
            "colinfo": columninfo,
            "code": edittingcode,
            "noconfirm": nocheck,
            "confirmedTypes": confirmedTypes
        };
    }
    function Save(finallycallback, nocheck, confirmedTypes) {
        var newfiles = (formstatus === "ENTRY FORM" ? [] : cfNewUploadFile(imageRef, fileRef)); //v1.4
        if (newfiles.length > 10) {
            fnc.current.warnmsg("新規登録できるアップロードファイル数は10までです。");
            return;
        }
        const paramdata = buildEntryParamData(nocheck, confirmedTypes);
        fnc.current.postaxios(formstatus === "ENTRY FORM" ? "RawTransfer/UpdateEntry" : "RawTransfer/InsertEntry", paramdata,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        let code = data.request;
                        if (formstatus !== "ENTRY FORM") {
                            let pkey = primarykey();
                            if (pkey !== "") entrydataRef.current[pkey] = data.request;
                            setedittingcode(data.request);
                            dispatch(changestatus("ENTRY FORM"));
                        }
                        if (newfiles.length !== 0) {        //v1.4
                            //新規ファイルアップロード
                            cfFileUpload("forms", code, newfiles, fnc, () => LoadData(code));
                        } else {
                            fnc.current.success();
                            if (formstatus === "ENTRY FORM") {
                                data.data['rowid'] = Getrowid();    //更新行キー
                                finallycallback(data.data);
                            }
                            LoadData(code);     //再表示
                        }
                    }
                    else {
                        if (isEnabled(data.confirm)) {
                            // 確認メッセージ
                            var msgs = ["内容を確認しそのまま登録する場合はOK,修正する場合はCancelを選択してください", "　"];

                            confirmedTypes = data.confirmedTypes;
                            // if (!confirmedTypes) {
                            //     confirmedTypes = [];
                            // }
                            for (let i = 0; i < data.warning.length; i++) {
                                if (data.warning[i].type) {
                                    confirmedTypes.push(data.warning[i].type);
                                }
                                msgs.push(data.warning[i].message);
                            }
                            fnc.current.confmsg(msgs, () => Save(finallycallback, true, confirmedTypes));
                        } else {
                            let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                            fnc.current.showwarndescription(msg, data.warning);
                        }
                    }
                    fnc.current.wait(false);
                },
                errmsg: "登録に失敗しました"
            }
        )
    }
    function Delete(finallycallback) {
        const param = {
            type: listoptionRef.current,
            data: entrydataRef.current,
            rowdata: [{ "rowid": edittingcode }],
            controller: controller
        }
        fnc.current.postaxios("RawTransfer/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(edittingcode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg(["このデータは削除できません", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "削除に失敗しました"
            }
        )
    }
    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }
    function LoadData(code) {
        if (code === "") return;
        fnc.current.postaxios('RawTransfer/GetData', { "code": code, "colinfo": columninfo, "controller": controller, type: listoptionRef.current },
            {
                onSuccess: function (data) {
                    try {
                        if (code !== "") {
                            //ViewからのMyField値を引継ぎ
                            let row = getglobaldata("entryrowdata");
                            const beforeData = entrydataRef.current;
                            fnc.current.margeMaster(data.master);
                            entrydataRef.current = keepListOptionValue(data.data, beforeData);
                            //行データ
                            for (let i = 0; i < gridlist.length; i++) {
                                if (!isEmpty(data.detail[gridlist[i].type])) {
                                    SetGridData({ id: gridlist[i].id }, data.detail[gridlist[i].type]);
                                    // if (existTotal(gridlist[i].id)) {
                                    //     //合計セット
                                    //     SetTotalData(gridlist[i].id, data.detail[gridlist[i].type], true);
                                    // }
                                }
                            }
                            gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
                                //PL行データ
                                SetGridData(l, fnc.current.PLRowData(data.data, l.type, columninfo));
                            });
                            // // const reqed = String(data.data["SJC_REQFLG"] ?? "") === "1";
                            // let reqFlg = String(data.data["SJC_REQFLG"] ?? "");
                            // let synFlg = String(data.data["SJC_SYNFLG1"] ?? "");
                            // let isEdit = !(reqFlg == "1" || synFlg == "2" || synFlg == "3");
                            // //setRowContext(fixed ? 1 : 0);
                            // setEntryMenu(reqFlg, synFlg);
                            // // getTorInfo();
                            // calcTotal();

                            // setEditable(isEdit);
                            // if (isEdit) {
                            //     setEditableTenjiNo();
                            // }
                            rerender();
                            dispatch(changestatus("ENTRY FORM"));
                        }
                        fnc.current.wait(false);
                    } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                    }
                },
                onError: function (data) {
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                    fnc.current.wait(false);
                }
            }
        )
    }
    // 編集可否
    function setEditable(edit) {
        let ids = ["SJC_JYUCYUKBN", "SJC_JYUCYUBI", "SJC_KEIJYODATE", "SJC_NOUKI", "SJC_YEAR", "SJC_SEASONCD", "SJC_SYOYU", "SJC_SAKUSEISYOYU", "SJC_BRDCD", "SJC_JYUCYUTANTOCD", "SJC_INPUTTANTOCD", "SJC_CONTRACTNO", "SJC_PONUMBER", "SJC_TEKIYO", "SJC_TOKUISAKIKBN", "SJC_TOKUISAKICD", "SJC_TOKUISAKITEL"];

        let locked = !edit;

        changeCellLocks(ids, locked);
    }
    //
    function changeCellLocks(columnids, locked) {
        const updateColumns = (fields) => {
            if (isEmpty(fields)) {
                return fields;
            }
            return fields.map(field => {
                if (!columnids.includes(field.columnid) || field.readonly === true) {
                    return field;
                }
                return { ...field, locked };
            });
        };
        settextfieldsall(prev => updateColumns(prev));
        settextfields(prev => updateColumns(prev));
    }
    function SetPLData() {
        gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
            let column = columninfo.find(e => e.type === l.type);
            if (!isEmpty(column)) {
                entrydataRef.current[column.columnid] = fnc.current.PLTextData(GridData(l), column.columnid);
            }
        });
    }
    // 入力フィールドクリア
    function clearform(newform) {
        const beforeData = entrydataRef.current;
        entrydataRef.current = keepListOptionValue(initializedata(textfieldsall, staff), beforeData);
        setEntryMenu("0", "0");
        imageRef.current = null;
        fileRef.current = null;
        scrollRef.current = null;
        for (let i = 0; i < gridlist.length; i++) {
            SetGridData(gridlist[i], null);
        }

        dispatch(setimagelist([]));
        fnc.current.modify(false);

        if (isEnabled(newform)) {
            //
            // setEditable(true);

            //SQL初期値セット
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
                {
                    onSuccess: function (data) {
                        for (let key in data.returnData) {
                            var col = textfieldsall.find(e => e.columnid === key);
                            if (!isEmpty(col)) col.initvalue = data.returnData[key];
                        }
                        entrydataRef.current = keepListOptionValue(initializedata(textfieldsall, staff), beforeData);

                        // setEditableTenjiNo();

                        rerender();
                    },
                }, true
            )
        }
    }
    //Basic Data Change
    function ValueChanged(id, value, edit) {
        if (edit) {
            if (id === 'ZFR_SYOYUM') {
                if (!("ZFR_SYOYUS" in entrydataRef.current)) {
                    entrydataRef.current = { ...entrydataRef.current, ZFR_SYOYUS: entrydataRef.current["ZFR_SYOYUM"] };
                }
            }
            if (id === 'ZFR_FURIKAEKBNM') {
                if (!("ZFR_FURIKAEKBNS" in entrydataRef.current)) {
                    entrydataRef.current = { ...entrydataRef.current, ZFR_FURIKAEKBNS: entrydataRef.current["ZFR_FURIKAEKBNM"] };
                }
            }
            if (id === 'ZFR_FURIKAEM') {
                if (!("ZFR_FURIKAES" in entrydataRef.current)) {
                    entrydataRef.current = { ...entrydataRef.current, ZFR_FURIKAES: entrydataRef.current["ZFR_FURIKAEM"] };
                }
            }
            if (id === 'ZFR_BRDCDM') {
                fnc.current.rerenderGrid("1");
            }
            if (id === 'ZFR_BRDCDS') {
                fnc.current.rerenderGrid("2");
            }
        }
        //外部からの参照がある項目
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col)) {
            if (col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }
    }
    // 
    function ChangeRowValue(params, panel) {
        if (panel.type === "110") {
            let gridData110 = GridData(panel) || [];
            let gridData112 = GridData("2") || [];

            if (isEmpty(gridData110)) {
                gridData110 = [];
                SetGridData(panel, gridData110);
            }
            if (isEmpty(gridData112)) {
                gridData112 = [];
                SetGridData("2", gridData112);
            }

            // let rowdata110 = gridData110.find(e => e.rowid === params.data.rowid);

            //gridData112 = { ...gridData110 };

            let a = [];

            for (let i = 0; i < gridData110.length; i++) {

                a.push({ rowid: i, ZFRM_ZAISIIRESAKICD: "70060" });

            }
            SetGridData("2", a);
            //rerender();

            fnc.current.rerenderGrid(fnc.current.GridID("2"));
            // fnc.current.rerenderGrid("2");
        }
        // if (panel.type === "112") {
        //     let gridData110 = GridData("110") || [];
        //     let gridData112 = GridData(panel) || [];

        //     if (isEmpty(gridData110)) {
        //         gridData110 = [];
        //         SetGridData("110", gridData110);
        //     }
        //     if (isEmpty(gridData112)) {
        //         gridData112 = [];
        //         SetGridData(panel, gridData112);
        //     }

        //     let rowdata1112 = gridData112.find(e => e.rowid === params.data.rowid);

        // }
        // if (params.column.colId === "SJCM_OPPIHINBAN") {
        //     getMPdtInfo(rowdata);
        // }
        // if (params.column.colId === "SJCM_COLORCD") {
        //     getMPdtcInfo(rowdata);
        //     getDetailInfo(rowdata);
        // }
        // if (params.column.colId === "SJCM_SIZECD") {
        //     getMPdtcInfo(rowdata);
        //     getDetailInfo(rowdata);
        // }
        // if (params.column.colId === "SJCM_JYUCYUSU") {
        //     calc(rowdata);
        //     reCalc();
        //     calcTotal();
        // }
        // if (params.column.colId === "SJCM_PBKBN") {
        //     reCalc();
        //     calcTotal();
        // }
        // if (params.column.colId === "SJCM_TANKA") {
        //     calc(rowdata, 1);
        //     reCalc(1);
        //     calcTotal();
        // }
        // if (params.column.colId === "SJCM_TANKAF") {
        //     calc(rowdata, 0);
        //     reCalc();
        // }
    }
    //
    function RowValueChanged(colid, targets, panel) {
        RowDataChanged(panel);
    }
    //
    function RowDataChanged(panel) {
        reCalc();
    }
    //明細編集セル制御
    function RowLockCell(params, edit, status, tabvalue) {

        let data = entrydataRef.current;

        // let reqFlg = String(data["SJC_REQFLG"] ?? "");
        // let synFlg = String(data["SJC_SYNFLG1"] ?? "");
        // let isEdit = !(reqFlg == "1" || synFlg == "2" || synFlg == "3");

        // if (!isEdit) {
        //     return false;
        // }
        // 振替元
        if (tabvalue === "110") {
            params.data["TYPE"] = "110";

            if (!entrydataRef.current["ZFR_BRDCDM"]) {
                if (params.colDef.colId === "ZFRM_ZAISIIRESAKICD") {
                    return false;
                }
            }
        }
        // 振替先
        if (tabvalue === "112") {
            params.data["TYPE"] = "112";

            if (!entrydataRef.current["ZFR_BRDCDS"]) {
                if (params.colDef.colId === "ZFRM_ZAISIIRESAKICD") {
                    return false;
                }
            }
        }
        if (!params.data["ZFRM_ZAISIIRESAKICD"]) {
            if (params.colDef.colId === "ZFRM_ZAIHINBAN") {
                return false;
            }
        }
        if (!params.data["ZFRM_ZAIHINBAN"]) {
            if (params.colDef.colId === "ZFRM_ZAICOLORCD" || params.colDef.colId === "ZFRM_TANSU" || params.colDef.colId === "ZFRM_METERSU") {
                return false;
            }
        }
        return edit;
    }
    // 品番情報取得
    function getMPdtInfo(rowdata) {
        var data = {};

        data["oppiCd"] = rowdata["SJCM_OPPIHINBAN"];

        if (isEmpty(data["oppiCd"])) {

            rowdata["SJCM_SENPOHINBAN"] = "";
            rowdata["SJCM_HINBAN"] = "";
            rowdata["SJCM_COLORCD"] = "";
            rowdata["SJCM_COLORNM"] = "";
            rowdata["SJCM_SIZECD"] = "";
            rowdata["SJCM_SIZENM"] = "";
            rowdata["SJCM_JYUCYUSU"] = 0;
            rowdata["SJCM_PBKBN"] = "0";
            rowdata["SJCM_JYODAI"] = 0;
            rowdata["SJCM_TANKA"] = 0;
            rowdata["SJCM_TANKAF"] = 0;
            rowdata["SJCM_IOTAXKBN"] = "";
            rowdata["SJCM_CHODATUZEIKBN"] = "";

            return;
        }
        fnc.current.postaxios('ProdSalesOrd/GetMPdtInfo',
            {
                type: listoptionRef.current,
                controller: controller,
                data: data
            },
            {
                onSuccess: function (data) {
                    fnc.current.wait(false);

                    rowdata["SJCM_HINBAN"] = data.rowdata["PDT_SYOHINCD"];
                    rowdata["SJCM_SENPOHINBAN"] = data.rowdata["PDT_MAKERHINBAN"];
                    rowdata["SJCM_COLORCD"] = "";
                    rowdata["SJCM_COLORNM"] = "";
                    rowdata["SJCM_SIZECD"] = "";
                    rowdata["SJCM_SIZENM"] = "";
                    rowdata["SJCM_JYUCYUSU"] = 0;
                    rowdata["SJCM_PBKBN"] = "0";
                    rowdata["SJCM_JYODAI"] = 0;
                    rowdata["SJCM_TANKA"] = 0;
                    rowdata["SJCM_TANKAF"] = 0;
                    rowdata["SJCM_IOTAXKBN"] = data.rowdata["PDT_HBZEIKBN"];
                    rowdata["SJCM_CHODATUZEIKBN"] = data.rowdata["PDT_CHODATUZEIKBN"];

                    fnc.current.rerenderGrid(fnc.current.GridID(G_id.MEI));

                    reCalc();
                    calcTotal();
                },
            },
            true
        )
    }
    // 品番情報取得
    function getMPdtcInfo(rowdata) {
        var data = {};

        data["oppiCd"] = rowdata["SJCM_OPPIHINBAN"];
        data["colorCd"] = rowdata["SJCM_COLORCD"];
        data["sizeCd"] = rowdata["SJCM_SIZECD"];

        if (isEmpty(data["oppiCd"])) {
            rowdata["SJCM_COLORCD"] = "";
            rowdata["SJCM_COLORNM"] = "";
            rowdata["SJCM_SIZECD"] = "";
            rowdata["SJCM_SIZENM"] = "";
            rowdata["SJCM_JYODAI"] = 0;
            return;
        }
        if (isEmpty(data["colorCd"])) {
            rowdata["SJCM_COLORCD"] = "";
            rowdata["SJCM_COLORNM"] = "";
            rowdata["SJCM_JYODAI"] = 0;
        }
        if (isEmpty(data["sizeCd"])) {
            rowdata["SJCM_SIZECD"] = "";
            rowdata["SJCM_SIZENM"] = "";
            rowdata["SJCM_JYODAI"] = 0;
        }
        fnc.current.postaxios('ProdSalesOrd/GetMPdtcInfo',
            {
                type: listoptionRef.current,
                controller: controller,
                data: data
            },
            {
                onSuccess: function (data) {
                    fnc.current.wait(false);

                    rowdata["SJCM_COLORNM"] = data.rowdata["PDTC_COLORNM"];
                    rowdata["SJCM_SIZENM"] = data.rowdata["SZE_SIZENM"];
                    rowdata["SJCM_JYODAI"] = data.rowdata["PDTC_PRICE"];

                    fnc.current.rerenderGrid(fnc.current.GridID(G_id.MEI));

                    reCalc();
                    calcTotal();
                },
            },
            true
        )
    }
    //
    function reCalc() {
        let id = G_id.MEI;
        let data = GridData(id);
        if (isEmpty(data)) {
            return;
        }
        // data.forEach(item => calc(item));

        // calcTotal();

        // fnc.current.rerenderGrid(id);
    }
    //
    function calcTotal() {
        let id = G_id.MEI;
        let data = GridData(id);
        if (isEmpty(data)) {
            return;
        }
        let total = getTotal(data);
        if (total === null) {
            return;
        }
        let rowNode = GridApi("T" + id).getRowNode("TOTAL");
        if (!isEmpty(rowNode)) {
            rowNode.setDataValue('SJC_QTY_T', total.qty);
            if (entrydataRef.current["SJC_TSUKATANI"] === "JPY") {
                rowNode.setDataValue('SJC_AMT_T', total.amt);
                rowNode.setDataValue('SJC_AMTF_T', 0);
            } else {
                rowNode.setDataValue('SJC_AMT_T', total.amt);
                rowNode.setDataValue('SJC_AMTF_T', total.amtf);
            }
        }
        fnc.current.rerenderGrid("T" + id);
    }
    //
    function getTotal(data) {
        let total = { qty: 0, amt: 0, amtf: 0 };
        for (let i = 0; i < data.length; i++) {
            total.qty += NumConv(data[i]["SJCM_JYUCYUSU"]);
            total.amt += NumConv(data[i]["SJCM_KINGAKU"]);
            total.amtf += NumConv(data[i]["SJCM_KINGAKUF"]);
        }
        return total;
    }
    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }
    //レイアウト保持
    function LayoutSaveStorage() {
        //列情報保存
        for (let i = 0; i < gridlist.length; i++) {
            AGRef.current.SaveColState(fnc.current.statusKey(gridlist[i].id, gridlist[i].type, formid), EmptyPanel(gridlist[i].id) ? null : GridColApi({ id: gridlist[i].id, type: gridlist[i].type }));
        }
        //基本情報保存
        Savestorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
    }
    //レイアウト登録
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            if (panel[p].id === G_id.BASE) {
                if (setbase) break;
                let fds = textfields.filter(x => !x.hide);
                for (let f = 0; f < fds.length; f++) {
                    coldef.push({
                        headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                        type: fds[f].type
                    });
                }
                setbase = true;
            } else {
                cols = AGRef.current.GetshownColDef(GridColApi({ id: panel[p].id }));
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id);
                coldef.push(col);
            }
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    //列情報初期化
                    for (let i = 0; i < gridlist.length; i++) {
                        var type = gridlist[i].type;
                        var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                        if (coldef.length === 0) continue;
                        SetGridColDef({ id: gridlist[i].id, type: gridlist[i].type }, coldef);
                    }
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }
    //リスト編集セル制御
    function ListlockCell(params, edit, status, tabvalue) {
        if (status === "INSERT") {
            //自テーブル以外編集不可
            if (tabvalue !== params.colDef.colinfo.type) return false;
        }
        return edit;
    }
    //idに対する合計行が存在するか
    function existTotal(id) {
        return gridlist.some(e => e.id === "T" + id);
    }
    //idに対する種別を取得
    function tabletype(id) {
        if (id.substr(0, 1) === "T") {  //Total
            if (isEmpty(columninfo)) return "";
            let col = columninfo.find(e => e.logpid === id);
            if (isEmpty(col)) return '';
            return col.type;
        } else {
            let pnl = panel.find(e => e.id === id);
            if (isEmpty(pnl)) return '';
            return pnl.type;
        }
    }

    //File Upload 再表示
    function fileuploaded(data) {
        let duplicate = false;
        if (formstatus === 'NEW FORM' || formstatus === 'COPY FORM') {  //v1.4
            if (cfMargeUploadFiles(imageRef, data.images)) duplicate = true;
            if (cfMargeUploadFiles(fileRef, data.files)) duplicate = true;
        } else {
            imageRef.current = data.images;
            fileRef.current = data.files;
        }
        dispatch(setimagelist(imageRef.current));
        rerender();
        //v1.4
        if (duplicate) fnc.current.warnmsg("同名のファイルが存在しました。差し替える場合は元のファイルを削除してからアップロードしてください");
    }


    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    //パネルセレクタ
    function panelnavwidth() {
        return windowDimensions.width - 280;
    }
    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.name}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} />
                ))}
            </ul>
        );
    });

    function Contents(props) {
        if (props.panel.id === G_id.BASE) {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} >
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.id === G_id.IMAGE) {
            return (
                <EntryImages
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={imageRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.grid) {
            if (props.panel.id !== G_id.PL) {
                return (
                    <React.Fragment>
                        <EntryGridAr
                            id={fnc.current.GridID(props.panel)}
                            entrydataRef={entrydataRef}
                            dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                            columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                            columninfo={columninfo}
                            columns={columns}
                            fnc={fnc}
                            onFirstDataRendered={onFirstDataRendered}
                            ValueChanged={(e) => ChangeRowValue(e, props.panel)}
                            RowValueChanged={(colid, rows) => RowValueChanged(colid, rows, props.panel)}
                            RemoveRow={() => RowDataChanged(props.panel)}
                            formid={formid}
                            panel={props.panel}
                            lockcell={RowLockCell}
                            rowContext={rowContext}
                        />
                        {!existTotal(props.panel.id) ? null :
                            <EntryGridAr
                                id={fnc.current.GridID("T" + props.panel.id)}
                                entrydataRef={entrydataRef}
                                dataRef={griddataRefs.current[fnc.current.gridindex("T" + props.panel.id)]}
                                columnRef={gridcolRefs.current[fnc.current.gridindex("T" + props.panel.id)]}
                                columninfo={columninfo}
                                columns={columns}
                                fnc={fnc}
                                onFirstDataRendered={onFirstDataRendered}
                                formid={formid}
                                panel={props.panel}
                                total={true}
                                totaltype={tabletype("T" + props.panel.id)}
                            />
                        }
                    </React.Fragment>
                );
            } else {
                return (
                    <EntryGridAr
                        id={fnc.current.GridID(props.panel)}
                        entrydataRef={entrydataRef}
                        dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                        columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                        columninfo={columninfo}
                        columns={columns}
                        fnc={fnc}
                        onFirstDataRendered={onFirstDataRendered}
                        formid={formid}
                        ValueChanged={() => storeRowData(props.panel)}
                        panel={props.panel}
                    />
                );
            }
        }
        if (props.panel.id === G_id.FILE) {
            return (
                <EntryFiles
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={fileRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.id === G_id.NB) {
            if (isEmpty(columninfo)) return null;
            let coldef = columninfo.find(e => e.type === props.panel.type);
            return (
                <EntryRemarks
                    id={"remarkspanel" + props.panel.type}
                    def={coldef}
                    dataRef={entrydataRef}
                    fnc={fnc}
                    ValueChanged={ValueChanged}
                />
            )
        }
        return null;

    }
    function EmptyPanel(id, type) {
        try {
            if (!panel.some(e => e.id === id)) return true; //パネル定義なし
            if (!isEmpty(type)) {
                if (!panel.some(e => e.id === id && e.type === type)) return true; //パネル定義なし
            }
            if (id === G_id.BASE) return isEmpty(textfields.find(e => e.type === type));
            let tbltype = tabletype(id);
            return !columns.some(e => e.type === tbltype);
        } catch { }
        return false;
    }
    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (p.id === G_id.IMAGE) {
            if (isEmpty(imageRef.current)) return true;
            if (imageRef.current.length === 0) return true;
            return p.hide;
        }
        if (p.id === G_id.FILE) {
            if (isEmpty(fileRef.current)) return true;
            if (fileRef.current.length === 0) return true;
            return p.hide;
        }
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }
    function tabChange(e) {
        baseRef.current.ListOptionShow(e === '0');
    }

    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', paddingBottom: '300px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef} onDragEnter={onDragEnter}>
                {panel.map((p, i) => {
                    return (
                        <Box
                            display={panelhidden(p) ? "none" : "flex"}
                            justifyContent="space-around"
                            alignItems="center"
                            padding="5px"
                        >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10
                                }}
                            >
                                <div style={{ position: 'relative', marginBottom: 5 }}>
                                    {p.name} - <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                    {p.id !== '0' || layoutlock ? null :
                                        <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                            <IconButton size="small" onClick={() => SetBaseField(p.type)}  >
                                                <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                    {layoutlock || sectionclose ? null :
                                        <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                            <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                                <Icon style={{ fontSize: 16 }}>close</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                </div>
                                <Contents panel={p} />
                            </Paper >
                        </Box>
                    );
                })}
            </div>
        );
    }
    return (
        <div>
            <ComFunc ref={fnc} />
            {/*primaryid削除　影響不明*/}
            <MasterBase
                ref={baseRef}
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                uploaded={fileuploaded}
                entrycallback={MenuAction}
                condition={true}
                entryform={true}
                tabs={true}
                show={Show}
                primarykey={primarykeys}
                entrydataRef={entrydataRef}
                navmenu={entrylock ? navmenu.filter(e => e.menuid !== 'formupload') : navmenu}
                suppressaction={suppressaction}
                lockcell={ListlockCell}
                usecondition={true}
                tabvalueChange={tabChange}
            >
                <EntryForm />
            </MasterBase>
            <EntryLayout
                columninfo={textfieldsall}
                textfields={textfields}
                onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <Headline columninfo={columninfo} entrydata={entrydataRef.current} hidden={panelhidden}></Headline>
                    <div style={{ position: 'absolute', top: 60, left: 210 }}>
                        <Paper
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexWrap: 'wrap',
                                listStyle: 'none',
                                p: 0.5,
                                m: 0,
                            }}
                            component="ul"
                            elevation={0}
                            style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                        >
                            {/*Panel Selector*/}
                            <SortablePanelSelector
                                axis={"x"}
                                items={panel}
                                onSortEnd={onPanelSortEnd}
                                distance={2}
                            />
                        </Paper>
                    </div>
                </div>
                : null}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
        </div>
    );
};
